import KeenSlider from 'keen-slider'

export function slider(element: HTMLElement): void {

  const width = (window.innerWidth < 1024) ? 348 : 620;
  const vw = (window.innerWidth > 1240)?1240:window.innerWidth;


  // This is taken directly from one of the Keen Slider examples but made TS 
  function navigation(slider: any) {
    let wrapper: HTMLElement, arrowLeft: HTMLElement, arrowRight: HTMLElement, nav: HTMLElement;

    function markup(remove: boolean) {
      wrapperMarkup(remove)
      arrowMarkup(remove)
    }

    function removeElement(elment: HTMLElement) {
      elment?.parentNode?.removeChild(elment)
    }
    function createDiv(className: string) {
      var div = document.createElement("div")
      var classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }

    function arrowMarkup(remove: boolean) {
      if (remove) {
        removeElement(arrowLeft)
        removeElement(arrowRight)
        return
      }
      arrowLeft = createDiv("arrow arrow--left")
      arrowLeft.addEventListener("click", () => slider.prev())
      arrowRight = createDiv("arrow arrow--right")
      arrowRight.addEventListener("click", () => slider.next())

      nav = createDiv("arrow__nav");

      nav.appendChild(arrowLeft)
      nav.appendChild(arrowRight)
      wrapper.appendChild(nav)
      
    }

    function wrapperMarkup(remove: boolean) {
      if (remove) {
        var parent = wrapper.parentNode
        while (wrapper.firstChild)
          parent?.insertBefore(wrapper.firstChild, wrapper)
        removeElement(wrapper)
        return
      }
      wrapper = createDiv("navigation-wrapper")
      slider.container.parentNode.appendChild(wrapper)
      wrapper.appendChild(slider.container)
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled");

      slide === slider.track.details.slides.length - Math.round(vw / width)
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled")
    }

    slider.on("created", () => {
      if (slider.slides.length <= 2 && window.innerWidth >= 1024) {
        return
      }
      markup(false)
      updateClasses()
    })
    slider.on("optionsChanged", () => {
      markup(true)
      markup(false)
      updateClasses()
    })
    slider.on("slideChanged", () => {
      updateClasses()
    })
    slider.on("destroyed", () => {
      markup(true)
    })
  }
  const slider = new KeenSlider(
    element,
    {
      drag: true,
      mode: "free",
      loop: false,
      slides: { perView: vw / width },
      defaultAnimation: {
        duration: 1000
      }
    },
    [navigation]
  )
}